<app-logo-area [breadcrumbs]="breadcrumbs()"></app-logo-area>
<main>
  <app-headline-section
    [title]="po_item_id()? po_item_id() + ' Preview' :''"></app-headline-section>

  @if (loadError()) {
    <section class="cl-section cl-section-regular">
      <div class="container"><p class="alert cl-alert-danger" role="alert">Could not load the encode: {{ loadError() }}</p></div>
    </section>
  }
  @if (poItem(); as poItem) {
    <section class="cl-section cl-section-regular">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <p class="alert cl-alert-action">

              @if (organization(); as organization) {
                @if (airline(); as airline) {
                  <a [routerLink]="['/o', organization.id, 'workflows', airline.iata_code, poItem.po.po_name]">
                    Back to PO
                  </a>

                  <a [routerLink]="['/o', organization.id, 'workflows', airline.iata_code, poItem.po.po_name, poItem.po_item_id]">
                    Back to PO Item
                  </a>
                }
              }
              @if ((PO_DESTINATIONS[poItem.po_destination] != null && PO_DESTINATIONS[poItem.po_destination].publishable)) {
                <a role="button" [class.cl-a-spinner]="publish_single_po_inflight"
                   [class.cl-a-disabled]="publishBlocked()" [attr.aria-disabled]="publishBlocked()"
                   (click)="publish_single_po(poItem)">
                  Publish
                </a>
              }
            </p>
          </div>
        </div>
      </div>
    </section>
  }

  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12">
          @if (poItem() && !hasManifest()) {
            <p class="alert cl-alert-info" role="alert">
              No preview available: it has expired or has not been generated yet.
            </p>
          } @else if (flytedgeMetadataUrl(); as flytedgeMetadataUrl) {
            <app-cl-tabs>
              <app-cl-tab tab_title="Video">
                @if (preview(); as preview) {
                  <app-player #tabbedPlayer
                              [m3u8]="preview.hls_manifest_url"
                              [manifest]="preview.dash_manifest_url"
                              [drmtodayToken]="preview.drmtoday_token"></app-player>
                  <app-video-ladder [m3u8]="preview.hls_manifest_url"
                                    [manifest]="preview.dash_manifest_url"
                                    [encrypted]="!!preview.drmtoday_token"
                                    [activeStreamType]="tabbedPlayer.streamType"
                                    [activeRendition]="tabbedPlayer.activeVideoRendition"
                                    [audioRenditions]="tabbedPlayer.audioRenditions"
                                    [textRenditions]="tabbedPlayer.textRenditions"
                                    [activeAudioRendition]="tabbedPlayer.activeAudioRendition"
                                    [activeTextRendition]="tabbedPlayer.activeTextRendition"
                                    (choose)="tabbedPlayer.applyLadderChoice($event)"
                                    (chooseAudio)="tabbedPlayer.applyAudioChoice($event)"
                                    (chooseText)="tabbedPlayer.applyTextChoice($event)"/>
                }
              </app-cl-tab>

              <app-cl-tab tab_title="Flytedge">
                <app-flytedge-metadata-preview [url]="flytedgeMetadataUrl"/>
              </app-cl-tab>
              <app-cl-tab tab_title="Flytedge Raw">
                <app-flytedge-metadata-raw [url]="flytedgeMetadataUrl"/>
              </app-cl-tab>
            </app-cl-tabs>
          } @else {
            @if (preview(); as preview) {
              <app-player #player
                          [m3u8]="preview.hls_manifest_url"
                          [manifest]="preview.dash_manifest_url"
                          [drmtodayToken]="preview.drmtoday_token"></app-player>
              <app-video-ladder [m3u8]="preview.hls_manifest_url"
                                [manifest]="preview.dash_manifest_url"
                                [encrypted]="!!preview.drmtoday_token"
                                [activeStreamType]="player.streamType"
                                [activeRendition]="player.activeVideoRendition"
                                [audioRenditions]="player.audioRenditions"
                                [textRenditions]="player.textRenditions"
                                [activeAudioRendition]="player.activeAudioRendition"
                                [activeTextRendition]="player.activeTextRendition"
                                (choose)="player.applyLadderChoice($event)"
                                (chooseAudio)="player.applyAudioChoice($event)"
                                (chooseText)="player.applyTextChoice($event)"/>
            }
          }
        </div>
      </div>
    </div>
  </section>


</main>
